export default {
    approveList: state => state.approveList,
    waitingFeedAnswers: state => state.waitingFeedAnswers,
    disasterCrisisIsApproved: state => state.disasterCrisisIsApproved,
    checkAnswerRules: state => state.checkAnswerRules,
    approveReplyResponse : state => state.approveReplyResponse,
    isSent:state=>state.isSent

};